import { createAction } from 'redux-actions';
export var NAMES = {
    PLAYER_MODULE_LOADED: 'CLIENT.DESKTOP.PLAYER_MODULE.LOADED',
};
export var playerModuleLoaded = createAction(NAMES.PLAYER_MODULE_LOADED);
